import {AppConfig} from '../types/app-types'

declare var process: {
  env: {
    [key: string]: string
  }
}

export function getConfig(): AppConfig {
  return {
    adyenClientId: process.env.ADYEN_CLIENT_ID,
    adyenEnvironment: process.env.ADYEN_ENVIRONMENT,
    bluemoonFormsBase: process.env.BLUEMOON_FORMS_BASE,
    bluemoonLeaseApiBase: process.env.BLUEMOON_LEASE_API_BASE,
    cognitoRegion: process.env.COGNITO_REGION,
    cognitoUserPoolId: process.env.COGNITO_USER_POOL_ID,
    cognitoWebClientId: process.env.COGNITO_WEB_CLIENT_ID,
    environment: process.env.ENVIRONMENT,
    loggingApiUrl: process.env.LOGGING_API_URL,
    loggingEnabled: process.env.LOGGING_ENABLED === 'true',
    loggingLevel: process.env.LOGGING_LEVEL,
    reduxDevTools: process.env.REDUX_DEV_TOOLS === 'true',
    residentPortalApiUrl: process.env.RESIDENT_PORTAL_API_URL,
    residentPortalWSUrl: process.env.RESIDENT_PORTAL_WS_URL
  }
}
